// extracted by mini-css-extract-plugin
module.exports = {"heading":"styles-module--heading--3xya4"};